import { render, staticRenderFns } from "./ContactsList.vue?vue&type=template&id=5e155124&scoped=true"
import script from "./ContactsList.vue?vue&type=script&lang=js"
export * from "./ContactsList.vue?vue&type=script&lang=js"
import style0 from "./ContactsList.vue?vue&type=style&index=0&id=5e155124&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e155124",
  null
  
)

export default component.exports